/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from './..\\..\\..\\com\\atproto\\label\\defs.defs.js'
import * as GraphDefs from './defs.defs.js'
import * as RichtextFacet from './..\\richtext\\facet.defs.js'

const $nsid = 'app.bsky.graph.list'

type $nsid = typeof $nsid

export { $nsid }

/** Record representing a list of accounts (actors). Scope includes both moderation-oriented lists and curration-oriented lists. */
type Main = {
  $type: 'app.bsky.graph.list'

  /**
   * Display name for list; can not be empty.
   */
  name: string
  avatar?: l.BlobRef
  labels?: l.$Typed<LabelDefs.SelfLabels> | l.Unknown$TypedObject

  /**
   * Defines the purpose of the list (aka, moderation-oriented or curration-oriented)
   */
  purpose: GraphDefs.ListPurpose
  createdAt: l.DatetimeString
  description?: string
  descriptionFacets?: RichtextFacet.Main[]
}

export type { Main }

/** Record representing a list of accounts (actors). Scope includes both moderation-oriented lists and curration-oriented lists. */
const main = /*#__PURE__*/ l.record<'tid', Main>(
  'tid',
  $nsid,
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string({ maxLength: 64, minLength: 1 }),
    avatar: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.blob({
        accept: ['image/png', 'image/jpeg'],
        maxSize: 1000000,
      }),
    ),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<LabelDefs.SelfLabels>(
            (() => LabelDefs.selfLabels) as any,
          ),
        ],
        false,
      ),
    ),
    purpose: /*#__PURE__*/ l.ref<GraphDefs.ListPurpose>(
      (() => GraphDefs.listPurpose) as any,
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 3000, maxGraphemes: 300 }),
    ),
    descriptionFacets: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<RichtextFacet.Main>(
          (() => RichtextFacet.main) as any,
        ),
      ),
    ),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
